import React from 'react';
import { ListItem, ListItemIcon, ListItemText, Typography, Box } from '@mui/material';

const CommandBarItem = ({ item, selected, onClick }) => {
  return (
    <ListItem
      component="div"
      selected={selected}
      onClick={() => onClick(item)}
      sx={{
        cursor: 'pointer',
        px: 2,
        py: 1,
        borderRadius: 1,
        mx: 1,
        my: 0.5,
        ...(selected && {
          bgcolor: 'primary.main',
          color: 'primary.contrastText',
          '&:hover': {
            bgcolor: 'primary.dark',
          },
        }),
      }}
    >
      {item.icon && (
        <ListItemIcon sx={{ minWidth: 32, color: selected ? 'inherit' : 'text.secondary' }}>
          <span style={{ fontSize: '16px' }}>{item.icon}</span>
        </ListItemIcon>
      )}
      <ListItemText
        primary={item.name || item.label || item.title}
        secondary={item.description}
        primaryTypographyProps={{
          variant: 'body2',
          fontWeight: selected ? 600 : 400,
        }}
        secondaryTypographyProps={{
          variant: 'caption',
          color: selected ? 'inherit' : 'text.secondary',
          sx: { opacity: selected ? 0.8 : 1 }
        }}
      />
      {item.shortcut && (
        <Box sx={{ ml: 1, opacity: 0.7 }}>
          <Typography variant="caption" sx={{ 
            bgcolor: selected ? 'rgba(255,255,255,0.2)' : 'action.hover',
            px: 0.8,
            py: 0.2,
            borderRadius: 0.5,
            fontFamily: 'monospace',
            fontSize: '11px'
          }}>
            {item.shortcut}
          </Typography>
        </Box>
      )}
    </ListItem>
  );
};

export default CommandBarItem;